function playback(backendAxiosInstance) {
  function playbackStreaming(playbackStreamingParams) {
    return backendAxiosInstance.post(
      "/experiences/v4/playback/streaming",
      playbackStreamingParams,
      {
        includeTimeZone: true,
        includeClientType: true
      }
    );
  }
  return {
    playbackStreaming
  };
}

export { playback as default };
//# sourceMappingURL=playback.js.map
